export type PaymentCreditCard = {
  id: number
  token: string
  brand: string
  name: string
  cpf: string
  card_mask: string
  expiration_month: string
  expiration_year: string
  created_at: string
  address_street: string
  address_number: string
  address_neighborhood: string
  address_zip: string
  address_city: string
  address_state: string
}

export type PaymentCreditCardCreate = Omit<PaymentCreditCard, 'id' | 'created_at'>

export type PaymentCredits = {
  balance: string
}

export type PaymentHistory = {
  id: number
  status: PaymentStatus
  method: PaymentMethods
  value: number
  created_at: string
  payment_transaction_id: string
  wallet_value: string
  external_value: string
}

export enum PaymentMethodEnum {
  CREDIT_CARD = 'CREDIT_CARD',
  PIX = 'PIX',
  CREDITS = 'CREDITS',
}

export const PaymentLabels = {
  [PaymentMethodEnum.CREDITS]: 'Carteira',
  [PaymentMethodEnum.CREDIT_CARD]: 'Cartão de Crédito',
  [PaymentMethodEnum.PIX]: 'Pix',
}

export type PaymentStatus = 'PENDING' | 'COMPLETED' | 'FAILED' | 'CANCELED'
export type PaymentMethods = (typeof PaymentMethodEnum)[keyof typeof PaymentMethodEnum]
export type ChargingPaymentMethod = Exclude<PaymentMethods, PaymentMethodEnum.CREDITS>

export type PaymentProduct = {
  id: number
  name: string
  amount: number
  discount: number
}

export type PaymentProductCreate = Omit<PaymentProduct, 'id'>
